import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';

import {Helper} from '../classes';
import {FeatureEnum} from '../enums';

/**
 * Blocks direct-URL access to routes whose feature flag is switched off.
 * Sidebar/tab visibility hides the navigation entry points; this guard closes the
 * saved-link and hand-typed-URL path so the release switch actually enforces the gate.
 * The expected feature travels in the route data: data: {featureFlag: FeatureEnum.X}.
 */
@Injectable({
    providedIn: 'root'
})
export class FeatureFlagGuard implements CanActivate {
    constructor(protected router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const feature: FeatureEnum = route.data.featureFlag;

        if (!feature || Helper.isFeatureEnabled(feature)) {
            return true;
        }

        this.router.navigate(['/error']).finally();

        return false;
    }
}
